import { render, staticRenderFns } from "./voucher-amount-selector.vue?vue&type=template&id=0c30dc22&"
import script from "./voucher-amount-selector.vue?vue&type=script&lang=js&"
export * from "./voucher-amount-selector.vue?vue&type=script&lang=js&"
import style0 from "./voucher-amount-selector.vue?vue&type=style&index=0&id=0c30dc22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports